/* eslint-disable @typescript-eslint/no-unused-vars */
import { EnvironmentTypes } from 'shared/constants/environmentTypes';
import { useAccess } from 'shared/hooks/useAccess/useAccess';

export const useFeatures = () => {
  const isDevelopmentEnvironment = useAccess({ environment: EnvironmentTypes.DEVELOPMENT });

  const isTestingEnvironment = useAccess({
    environment: [EnvironmentTypes.TESTING, EnvironmentTypes.DEVELOPMENT],
  });

  return {
    creditReview: false,
    creditReviewInvitationCard: false,
    esg: true,
    shopSystem: true,
    notifications: true,
    esgCompanies: true,
    eventsInPortfolioManager: true,
    activityInPortfolioManager: true,
    uploadsHistoryInPortfolioManager: true,
    restrictedSubscriptionRatings: isTestingEnvironment,
    creditSphereInvitationCard: false,
    esgLendingData: true,
    esgSentiment: false,
    climateStressTest: true,
    popoverFiltersPortfolioManager: true,
    ecafFeature: true,
    multipleRequestsPortfolioManager: true,
    redirectHomeToPageOne: true,
    fundAnalysisPortfolioManager: true,
    newPortfolioUploadModal: true,
    questionnaire: false,
  };
};
